// src/components/ui/button.jsx
import React from "react";

export function Button({
  children,
  className = "",
  variant = "default",
  size = "default",
  disabled = false,
  onClick,
  type = "button",
  ...props
}) {
  const baseStyles =
    "inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none";

  const variants = {
    default:
      "bg-indigo-600 text-white hover:bg-indigo-700 focus-visible:ring-indigo-500",
    destructive:
      "bg-red-600 text-white hover:bg-red-700 focus-visible:ring-red-500",
    outline:
      "border border-gray-300 bg-white hover:bg-gray-50 text-gray-700 hover:text-gray-900 focus-visible:ring-gray-400",
    secondary:
      "bg-gray-100 text-gray-900 hover:bg-gray-200 focus-visible:ring-gray-500",
    ghost:
      "hover:bg-gray-100 text-gray-700 hover:text-gray-900 focus-visible:ring-gray-400",
    link: "text-indigo-600 hover:text-indigo-700 underline-offset-4 hover:underline focus-visible:ring-indigo-500 p-0 h-auto",
    success:
      "bg-green-600 text-white hover:bg-green-700 focus-visible:ring-green-500",
    warning:
      "bg-amber-500 text-white hover:bg-amber-600 focus-visible:ring-amber-500",
  };

  const sizes = {
    default: "h-10 py-2 px-4 text-sm",
    sm: "h-8 px-3 text-xs",
    lg: "h-11 px-8 text-base",
    icon: "h-10 w-10",
    "icon-sm": "h-8 w-8",
  };

  const variantStyle = variants[variant] || variants.default;
  const sizeStyle = sizes[size] || sizes.default;

  return (
    <button
      type={type}
      className={`${baseStyles} ${variantStyle} ${sizeStyle} ${className}`}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
}

export default Button;
